import { Box, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"

const StyledGreyBox = styled(Box)(({ theme }) => ({
  borderBottom: "1px solid",
  borderBottomColor: theme.palette.grey[300]
}))

export const ReadMoreReadLessTitle = ({ t }) => {
  return (
    <>
      <Typography mb={2} fontSize="13px" color="warning.main">
        {t("issuereports.check_to_avoid_duplicates", "Check existing issue reports to avoid duplicates")}{" "}
      </Typography>
      <StyledGreyBox display="flex" justifyContent="space-between">
        <Typography mb={1} fontWeight="600" variant="bodySmall">
          {t("global.description", "Description")}
        </Typography>
        <Typography mb={1} fontWeight="600" variant="bodySmall">
          {t("global.date", "Date")}
        </Typography>
      </StyledGreyBox>
    </>
  )
}
